module.exports = __webpack_public_path__ + "static/traditional-b936bdc7eaae58520b8ebe69a9e6170c.png";